module.exports = __webpack_public_path__ + "img/4-2-4-3-8-preview-billy-e.e9206618.jpg";